import { Form, Input } from "antd";
import { useIntl } from "react-intl";
import PhoneInputWithCountrySelect from "react-phone-number-input";

const NumberNameEmail = ({ value, setValue }: any) => {
  const intl = useIntl();

  return (
    <div className="flex w-full max-xl:flex-wrap gap-x-4">
      <Form.Item
        name={["name", "ar"]}
        label={intl.formatMessage({ id: "intl.form.label.branch_name" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "intl.form.message.required_branch_name",
            }),
          },
        ]}
        required={false}
        hasFeedback
        className="w-1/2 max-xl:w-full"
      >
        <Input
          placeholder={intl.formatMessage({
            id: "intl.form.placeholder.enter_branch_name",
          })}
          className="w-full"
        />
      </Form.Item>
      <Form.Item
        label={intl.formatMessage({ id: "intl.form.label.mobile_number" })}
        name="phone"
        required={false}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "intl.form.message.required_mobile_number",
            }),
          },
        ]}
        className="w-1/4 max-xl:w-[47.5%]"
        hasFeedback
      >
        <PhoneInputWithCountrySelect
          defaultCountry="SA"
          value={value}
          onChange={setValue}
          international
          hasFeedback
          limitMaxLength={true}
          className="!border-[1px] !border-solid !border-color-primary !py-2 !px-[11px] !h-[42px]"
        />
      </Form.Item>
      <Form.Item
        name={"email"}
        label={intl.formatMessage({ id: "intl.form.label.branch_email" })}
        rules={[
          {
            required: true,
            type: "email",
            message: intl.formatMessage({
              id: "intl.form.message.email_validation",
            }),
          },
        ]}
        required={false}
        hasFeedback
        className="w-1/4 max-xl:w-[47.5%]"
      >
        <Input
          placeholder={intl.formatMessage({
            id: "intl.form.placeholder.enter_branch_email",
          })}
        />
      </Form.Item>
    </div>
  );
};

export default NumberNameEmail;
